import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as colors from '../../../config/Colors/Ligth';

export const HeaderLista = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  min-height: 140px;
  >div:first-child{
    display: flex;
  flex-direction: row;
  justify-content: space-between;
  }
  h1 {
    font-size: 1.4rem;
    color: ${colors.titleFontColor};
  }
`;

export const BodyLista = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinkContainer = styled(Link)`
  &:hover {
    h2 {
      color:  ${colors.pedido};
    }
    filter: brightness(90%);

  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 3px 0;
  border-bottom: 1px solid #eee;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    h2 {
      color: ${colors.titleFontColor};
      font-size: 14px;
      @media only screen and (max-width: 992px) {
        font-size: 12px;
      }
    }
    span {
      color: ${colors.ligthFontColor};
      font-size: 10px;
      svg {
        font-size: 12px;
      }
      font-weight: 600;
      display: flex;
      align-items: flex-start;
      @media only screen and (max-width: 992px) {
        font-size: 8px;
        svg {
          font-size: 10px;
        }
      }
    }
    div {
      margin-top: 2px;
    }
  }
`;

export const ContainerGrupoProduto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  p {
    background-color: #f4f2f5;
    font-size: 10px;
    font-weight: 500;
    padding: 0 2px;
    border-radius: 4px;
  }
`;
